import MessageConfirmation from './message-confirmation'

export default MessageConfirmation
